import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c082d16e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArchiveContracts" }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contract_register_add_new = _resolveComponent("contract-register-add-new")!
  const _component_attach_document_form = _resolveComponent("attach-document-form")!
  const _component_contract_register_add = _resolveComponent("contract-register-add")!
  const _component_d24_form = _resolveComponent("d24-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_add)
      ? (_openBlock(), _createBlock(_component_contract_register_add_new, {
          key: 0,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_add = false)),
          onAdded: _ctx.onContractAdded
        }, null, 8, ["onAdded"]))
      : _createCommentVNode("", true),
    (_ctx.state_attach.is_open)
      ? (_openBlock(), _createBlock(_component_attach_document_form, {
          key: 1,
          contract: _ctx.state_attach.contract,
          loading: _ctx.state_attach.is_loading,
          "is-register": "",
          onCancel: _ctx.toggleAttach,
          onSubmit: _ctx.onAttach
        }, null, 8, ["contract", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state_add.is_open)
      ? (_openBlock(), _createBlock(_component_contract_register_add, {
          key: 2,
          "contract-id": _ctx.state_add.contract.id,
          contract: _ctx.state_add.contract,
          onCancel: _ctx.toggleAdd,
          onAdded: _ctx.onAdded
        }, null, 8, ["contract-id", "contract", "onCancel", "onAdded"]))
      : (_ctx.state_d24.is_open)
        ? (_openBlock(), _createBlock(_component_d24_form, {
            key: 3,
            contract: _ctx.state_d24.contract,
            "is-register": "",
            onSubmit: _ctx.onD24Submit,
            onCancel: _ctx.toggleD24
          }, null, 8, ["contract", "onSubmit", "onCancel"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_page_title, { title: "Реестр договоров" }),
              _createElementVNode("div", null, [
                (_ctx.havePermissions(['contract-register-create']))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_add = true)),
                      class: "primary small mr-2",
                      loading: _ctx.state.contracts.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Создать запись ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_button, {
                  onClick: _ctx.exportExcel,
                  class: "primary small",
                  loading: _ctx.state.contracts.is_loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать в Excel ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.loadRegisterContracts(1)), ["prevent"])),
              class: "bg-white border px-4 py-2 mt-6"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_input, {
                  placeholder: "Номер договора",
                  value: _ctx.filters_state.number,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.number) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  placeholder: "Подразделение",
                  loading: _ctx.data_state.subdivisions.is_loading,
                  failed: _ctx.data_state.subdivisions.is_failed,
                  "error-text": "При получении списка произошла ошибка",
                  options: _ctx.data_state.subdivisions.list,
                  value: _ctx.filters_state.subdivisionIds,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.subdivisionIds) = $event)),
                  onRefresh: _ctx.loadSubdivisions,
                  multiselect: ""
                }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  placeholder: "Тип договора",
                  options: _ctx.data_state.types.list,
                  loading: _ctx.data_state.types.is_loading,
                  failed: _ctx.data_state.types.is_failed,
                  "error-text": "При получении списка произошла ошибка",
                  value: _ctx.filters_state.typeIds,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.typeIds) = $event)),
                  "infinite-scroll": "",
                  onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
                  onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1))),
                  multiselect: ""
                }, null, 8, ["options", "loading", "failed", "value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Дата выдачи от",
                  value: _ctx.filters_state.dateOfIssueFrom,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.dateOfIssueFrom) = $event)),
                  type: "date"
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Дата выдачи до",
                  value: _ctx.filters_state.dateOfIssueTo,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.dateOfIssueTo) = $event)),
                  type: "date"
                }, null, 8, ["value"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  value: _ctx.filters_state.initiatorIds,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters_state.initiatorIds) = $event)),
                  placeholder: "Инициатор",
                  loading: _ctx.data_state.initiators.is_loading,
                  options: _ctx.data_state.initiators.list,
                  failed: _ctx.data_state.initiators.is_failed,
                  "error-text": "При получении списка произошла ошибка",
                  "infinite-scroll": "",
                  onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadInitiators(_ctx.data_state.initiators.pagination.current_page))),
                  onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (
                            _ctx.loadMoreInitiators(_ctx.data_state.initiators.pagination.current_page + 1)
                        )),
                  onSearch: _ctx.searchInitiators,
                  onOptionBySearch: _ctx.unshiftFindedInitiator,
                  multiselect: ""
                }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
                _createVNode(_component_the_select, {
                  class: "mt-2",
                  value: _ctx.filters_state.statusIds,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.statusIds) = $event)),
                  placeholder: "Статус",
                  loading: _ctx.data_state.statuses.is_loading,
                  options: _ctx.data_state.statuses.list,
                  failed: _ctx.data_state.statuses.is_failed,
                  "error-text": "При получении списка произошла ошибка",
                  "infinite-scroll": "",
                  onRefresh: _ctx.loadStatuses,
                  multiselect: ""
                }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
                _createVNode(_component_the_input, {
                  placeholder: "Компания",
                  value: _ctx.filters_state.companyName,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters_state.companyName) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "БИН",
                  value: _ctx.filters_state.companyBin,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters_state.companyBin) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Дата от",
                  value: _ctx.filters_state.dateCreatedFrom,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters_state.dateCreatedFrom) = $event)),
                  type: "date"
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Дата до",
                  value: _ctx.filters_state.dateCreatedTo,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters_state.dateCreatedTo) = $event)),
                  type: "date"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_the_button, {
                  class: "second text small mr-2",
                  loading: _ctx.state.contracts.is_loading,
                  onClick: _ctx.resetFilters
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createTextVNode(" Сброс ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.contracts.is_loading,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createTextVNode(" Поиск ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_8, [
              (
                        _ctx.state.contracts.is_failed && !_ctx.state.contracts.failure.error_state.is_cancel
                    )
                ? (_openBlock(), _createBlock(_component_failed_fetch, {
                    key: 0,
                    loading: _ctx.state.contracts.is_loading,
                    text: "При получении списка произошла ошибка",
                    "error-message": _ctx.state.contracts.failure.error_state.message,
                    "error-url": _ctx.state.contracts.failure.error_state.url,
                    "error-status": _ctx.state.contracts.failure.error_state.status,
                    onRefresh: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadRegisterContracts(_ctx.state.contracts.pagination.current_page)))
                  }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
                : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                    key: 1,
                    loading: _ctx.state.contracts.is_loading
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_table, {
                        loading: _ctx.state.contracts.is_loading,
                        columns: _ctx.COLUMNS,
                        rows: _ctx.state.contracts.list,
                        "with-limit": "",
                        "pagination-limit": _ctx.filters_state.limit,
                        "pagination-total-items": _ctx.state.contracts.pagination.total_items,
                        "pagination-current-page": _ctx.state.contracts.pagination.current_page,
                        "pagination-total-pages": _ctx.state.contracts.pagination.total_pages,
                        onChangePage: _ctx.loadRegisterContracts,
                        onChangeLimit: _ctx.onLimitChange
                      }, {
                        buttons: _withCtx(() => [
                          _createVNode(_component_the_button, {
                            class: "primary small mr-3",
                            loading: _ctx.state.contracts.is_loading,
                            onClick: _ctx.tablesStore.toggleModal
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }, 8, ["loading", "onClick"])
                        ]),
                        td: _withCtx(({ column, row }) => [
                          (column.key === 'id')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/contracts/register/${row.id}`,
                                class: "ArchiveContracts__link"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.id), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (column.key === 'number' && row.contractId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: `/contracts/${row.contractId}`,
                                  class: "ArchiveContracts__link"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.number), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (column.key === 'status')
                                ? (_openBlock(), _createBlock(_component_cheap, {
                                    key: 2,
                                    class: _normalizeClass(["small", _ctx.getStatusColor(row.status.id)])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(row.status.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : (column.key === 'date')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                                    ], 64))
                                  : (column.key === 'createdAt')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                                      ], 64))
                                    : (column.key === 'type')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _createTextVNode(_toDisplayString(row.type.name), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                                        ], 64))
                        ]),
                        actions: _withCtx(({ row }) => [
                          (row.status && row.status.canUploadDocument)
                            ? (_openBlock(), _createBlock(_component_button_dropdown, {
                                key: 0,
                                icon: "fas fa-ellipsis-h",
                                class: "max-w-min"
                              }, {
                                default: _withCtx(() => [
                                  (
                                        row.type &&
                                        row.type.isMain &&
                                        _ctx.havePermissions(['contract-contract-create'])
                                    )
                                    ? (_openBlock(), _createBlock(_component_the_button, {
                                        key: 0,
                                        class: "text small",
                                        onClick: ($event: any) => (_ctx.toggleAdd(row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Добавить договор ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.havePermissions(['contract-dogovor24-send']))
                                    ? (_openBlock(), _createBlock(_component_the_button, {
                                        key: 1,
                                        class: "text small",
                                        onClick: ($event: any) => (_ctx.toggleD24(row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Отправить в Д24 ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (
                                        row.type &&
                                        !row.type.isMain &&
                                        _ctx.havePermissions(['contract-contract-create'])
                                    )
                                    ? (_openBlock(), _createBlock(_component_the_button, {
                                        key: 2,
                                        class: "text small",
                                        onClick: ($event: any) => (_ctx.toggleAttach(row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Прикрепить к основному договору ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
            ])
          ]))
  ]))
}